import { Breakpoints } from '@angular/cdk/layout';
import { BreakpointSize } from './breakpoint-size.type';

/**
 * Tracks the minimum and maximum bounds of a responsive breakpoint.
 */
export type ResponsiveBreakpoint<T = number | string> = {
  /**
   * The minimum bounds of a responsive breakpoint.
   */
  begin: T;

  /**
   * The maximum bounds of a responsive breakpoint.
   */
  end: T;
};

/**
 * Tracks the minimum and maximum values for responsive breakpoints.
 */
export type ResponsiveBreakpoints<T = number | string> = {
  [size in keyof typeof BreakpointSize]: ResponsiveBreakpoint<T>;
};

/**
 * The responsive breakpoint bounds.
 */
export const MIN_WIDTH_REGEX: (value: string) => string = (value: string): string =>
  value.match(/min-width:\s*([\d.]*\w*)/)?.at(1) ?? '0px';
export const MAX_WIDTH_REGEX: (value: string) => string = (value: string): string =>
  value.match(/max-width:\s*([\d.]*\w*)/)?.at(1) ?? `${Number.MAX_SAFE_INTEGER}px`;

/**
 * Default values for the start and end sizes of each reactive breakpoint.
 */
export const DEFAULT_BREAKPOINTS: ResponsiveBreakpoints<number> = {
  XSmall: {
    begin: parseFloat(MIN_WIDTH_REGEX(Breakpoints.XSmall)),
    end: parseFloat(MAX_WIDTH_REGEX(Breakpoints.XSmall))
  },
  Small: {
    begin: parseFloat(MIN_WIDTH_REGEX(Breakpoints.Small)),
    end: parseFloat(MAX_WIDTH_REGEX(Breakpoints.Small))
  },
  Medium: {
    begin: parseFloat(MIN_WIDTH_REGEX(Breakpoints.Medium)),
    end: parseFloat(MAX_WIDTH_REGEX(Breakpoints.Medium))
  },
  Large: {
    begin: parseFloat(MIN_WIDTH_REGEX(Breakpoints.Large)),
    end: parseFloat(MAX_WIDTH_REGEX(Breakpoints.Large))
  },
  XLarge: {
    begin: parseFloat(MIN_WIDTH_REGEX(Breakpoints.XLarge)),
    end: parseFloat(MAX_WIDTH_REGEX(Breakpoints.XLarge))
  }
};
